import React, { useState, useEffect } from 'react';
import { CopyNotification, setNotificationCallback } from './copy-notification';

export const CopyNotificationContainer: React.FC = () => {
    const [notifications, setNotifications] = useState<Array<{ id: number; message: string }>>([]);

    useEffect(() => {
        setNotificationCallback((message: string) => {
            const id = Date.now();
            setNotifications(prev => [...prev, { id, message }]);
        });

        return () => {
            setNotificationCallback(null);
        };
    }, []);

    const removeNotification = (id: number) => {
        setNotifications(prev => prev.filter(notification => notification.id !== id));
    };

    return (
        <div className="fixed top-4 right-4 z-[100] space-y-2">
            {notifications.map((notification) => (
                <CopyNotification
                    key={notification.id}
                    message={notification.message}
                    onClose={() => removeNotification(notification.id)}
                />
            ))}
        </div>
    );
};
